'use strict';

/* globals $, window, document, ajaxify, socket */

(function () {
	let posts = [];
	const modify = (em) => {
		const footer = $(em).find('.post-footer')[0];
		const votes = $(em).find('.votes')[0];
		const postId = parseInt($(footer).parent('li').attr('data-pid'), 10);

		if (!(footer && votes)) { return; }
		if ($(votes).attr('data-moded')) { return; }

		$(footer).find('small.pull-right').prepend(votes); // Pull votes to the left
		// $(footer).prepend(votes); // Pull votes to the left
		$(votes).find('[component="post/vote-count"]').remove(); // Remove aggregated votes

		const post = posts.find(({ pid }) => pid === postId);
		if (!post) { return; }
		// Add upvote count
		const upvoteCount = $(document.createElement('span')).addClass('upvote-count vote-count').text(post.upvotes);
		const upvote = $(votes).find('[component="post/upvote"]');
		upvote.find('i').removeClass().addClass('fa fa-thumbs-up');
		upvote.after(upvoteCount);

		// Add downvote count
		const downvoteCount = $(document.createElement('span')).addClass('downvote-count vote-count').text(post.downvotes);
		const downvote = $(votes).find('[component="post/downvote"]');
		downvote.find('i').removeClass().addClass('fa fa-thumbs-down');
		downvote.after(downvoteCount);

		// Mark status
		$(votes).attr('data-moded', true);
	};

	const scan = () => {
		const postsEm = document.querySelectorAll('[component="post"]');
		// console.log({ postsEm });
		postsEm.forEach(modify);
	};

	$(window).on('action:topic.loaded', () => {
		posts = posts.concat(ajaxify.data.posts);
		scan();

		socket.on('event:voted', (data) => {
			// console.log({ data });
			const { post } = data;
			const { pid, downvotes, upvotes } = post;
			const filter = (index, el) => parseInt($(el).closest('[data-pid]').attr('data-pid'), 10) === parseInt(pid, 10);
			const upvotesEl = $(`[data-pid="${pid}"] .upvote-count`).filter(filter);
			upvotesEl.text(upvotes);
			const downvotesEl = $(`[data-pid="${pid}"] .downvote-count`).filter(filter);
			downvotesEl.text(downvotes);
		});
	});

	$(window).on('action:posts.loaded', (e) => {
		if (e.target && e.target.ajaxify && e.target.ajaxify.data) {
			posts = posts.concat(e.target.ajaxify.data.posts || []);
			scan();
		}
	});
}());
